// import React, { Fragment, Component } from 'react';
// import Spinner from '../layout/Spinner';
// import Repos from '../repos/Repos';
// import PropTypes from 'prop-types';
// import { Link } from 'react-router-dom';
// export class User extends Component {
//   componentDidMount() {
//     this.props.getUser(this.props.match.params.login);
//     this.props.getUserRepos(this.props.match.params.login);
//   }
//   static propsTypes = {
//     getUser: PropTypes.func.isRequired,
//     getUserRepos: PropTypes.func.isRequired,
//     loading: PropTypes.bool,
//     user: PropTypes.object.isRequired,
//     repos: PropTypes.array.isRequired,
//   };
//   render() {
//     const {
//       name,
//       company,
//       avatar_url,
//       location,
//       bio,
//       blog,
//       login,
//       html_url,
//       followers,
//       following,
//       public_repos,
//       public_gists,
//       hireable,
//     } = this.props.user;
//     const { loading, repos } = this.props;
//     if (loading) {
//       return <Spinner />;
//     } else {
//       return (
//         <Fragment>
//           <Link to='/' className='btn btn-light'>
//             Back to Search
//           </Link>
//           Hireable:{' '}
//           {hireable ? (
//             <i className='fa fa-check text-success'></i>
//           ) : (
//             <i className='fa fa-times-circle text-danger'></i>
//           )}
//           <div className='card grid-2'>
//             <div className='all-center'>
//               <img
//                 src={avatar_url}
//                 alt='User'
//                 style={{ width: '150px' }}
//                 className='round-img'
//               />
//               <h1>{name}</h1>
//               <p>Location: {location} </p>
//             </div>
//             <div>
//               {bio && (
//                 <Fragment>
//                   <h3>Bio</h3>
//                   <p>{bio} </p>
//                 </Fragment>
//               )}
//               <a href={html_url} className='btn btn-dark my-1'>
//                 Visit Github Profile
//               </a>
//               <ul>
//                 <li>
//                   {login && (
//                     <Fragment>
//                       <strong>Username</strong> {login}
//                     </Fragment>
//                   )}
//                 </li>
//                 <li>
//                   {company && (
//                     <Fragment>
//                       <strong>Company</strong> {login}
//                     </Fragment>
//                   )}
//                 </li>
//                 <li>
//                   {blog && (
//                     <Fragment>
//                       <strong>Website</strong> {blog}
//                     </Fragment>
//                   )}
//                 </li>
//               </ul>
//             </div>
//           </div>
//           <div className='card text-center'>
//             <div className='badge badge-primary'>Followers: {followers} </div>
//             <div className='badge badge-success'>Following: {following} </div>
//             <div className='badge badge-light'>
//               Public Repos: {public_repos}{' '}
//             </div>
//             <div className='badge badge-dark'>
//               Public Gists: {public_gists}{' '}
//             </div>
//           </div>
//           <Repos repos={repos} />
//         </Fragment>
//       );
//     }
//   }
// }

// export default User;
//REFORMING/////////////////////////////////////////////
// import React, { Fragment, useEffect } from 'react';
// import Spinner from '../layout/Spinner';
// import Repos from '../repos/Repos';
// import PropTypes from 'prop-types';
// import { Link } from 'react-router-dom';

// const User = ({ loading, repos, user, match, getUserRepos, getUser }) => {
//   useEffect(() => {
//     getUser(match.params.login);
//     getUserRepos(match.params.login);
//     // eslint-disable-next-line
//   }, []);

//   const {
//     name,
//     company,
//     avatar_url,
//     location,
//     bio,
//     blog,
//     login,
//     html_url,
//     followers,
//     following,
//     public_repos,
//     public_gists,
//     hireable,
//   } = user;

//   if (loading) {
//     return <Spinner />;
//   } else {
//     return (
//       <Fragment>
//         <Link to='/' className='btn btn-light'>
//           Back to Search
//         </Link>
//         Hireable:{' '}
//         {hireable ? (
//           <i className='fa fa-check text-success'></i>
//         ) : (
//           <i className='fa fa-times-circle text-danger'></i>
//         )}
//         <div className='card grid-2'>
//           <div className='all-center'>
//             <img
//               src={avatar_url}
//               alt='User'
//               style={{ width: '150px' }}
//               className='round-img'
//             />
//             <h1>{name}</h1>
//             <p>Location: {location} </p>
//           </div>
//           <div>
//             {bio && (
//               <Fragment>
//                 <h3>Bio</h3>
//                 <p>{bio} </p>
//               </Fragment>
//             )}
//             <a href={html_url} className='btn btn-dark my-1'>
//               Visit Github Profile
//             </a>
//             <ul>
//               <li>
//                 {login && (
//                   <Fragment>
//                     <strong>Username</strong> {login}
//                   </Fragment>
//                 )}
//               </li>
//               <li>
//                 {company && (
//                   <Fragment>
//                     <strong>Company</strong> {login}
//                   </Fragment>
//                 )}
//               </li>
//               <li>
//                 {blog && (
//                   <Fragment>
//                     <strong>Website</strong> {blog}
//                   </Fragment>
//                 )}
//               </li>
//             </ul>
//           </div>
//         </div>
//         <div className='card text-center'>
//           <div className='badge badge-primary'>Followers: {followers} </div>
//           <div className='badge badge-success'>Following: {following} </div>
//           <div className='badge badge-light'>Public Repos: {public_repos} </div>
//           <div className='badge badge-dark'>Public Gists: {public_gists} </div>
//         </div>
//         <Repos repos={repos} />
//       </Fragment>
//     );
//   }
// };

// User.propsTypes = {
//   getUser: PropTypes.func.isRequired,
//   getUserRepos: PropTypes.func.isRequired,
//   loading: PropTypes.bool,
//   user: PropTypes.object.isRequired,
//   repos: PropTypes.array.isRequired,
// };

// export default User;
//REFORMING WITH CONTEXT//////////////////////////////////////
import React, { Fragment, useEffect, useContext } from 'react';
import Spinner from '../layout/Spinner';
import Repos from '../repos/Repos';
import { Link } from 'react-router-dom';
import GithubContext from '../../context/github/githubContext';
const User = ({ match }) => {
  const githubContext = useContext(GithubContext);
  const { loading, user, getUser, getUserRepos, repos } = githubContext;
  useEffect(() => {
    getUser(match.params.login);
    getUserRepos(match.params.login);
    // eslint-disable-next-line
  }, []);

  const {
    name,
    company,
    avatar_url,
    location,
    bio,
    blog,
    login,
    html_url,
    followers,
    following,
    public_repos,
    public_gists,
    hireable,
  } = user;

  if (loading) {
    return <Spinner />;
  } else {
    return (
      <Fragment>
        <Link to='/' className='btn btn-light'>
          Back to Search
        </Link>
        Hireable:{' '}
        {hireable ? (
          <i className='fa fa-check text-success'></i>
        ) : (
          <i className='fa fa-times-circle text-danger'></i>
        )}
        <div className='card grid-2'>
          <div className='all-center'>
            <img
              src={avatar_url}
              alt='User'
              style={{ width: '150px' }}
              className='round-img'
            />
            <h1>{name}</h1>
            <p>Location: {location} </p>
          </div>
          <div>
            {bio && (
              <Fragment>
                <h3>Bio</h3>
                <p>{bio} </p>
              </Fragment>
            )}
            <a href={html_url} className='btn btn-dark my-1'>
              Visit Github Profile
            </a>
            <ul>
              <li>
                {login && (
                  <Fragment>
                    <strong>Username</strong> {login}
                  </Fragment>
                )}
              </li>
              <li>
                {company && (
                  <Fragment>
                    <strong>Company</strong> {login}
                  </Fragment>
                )}
              </li>
              <li>
                {blog && (
                  <Fragment>
                    <strong>Website</strong> {blog}
                  </Fragment>
                )}
              </li>
            </ul>
          </div>
        </div>
        <div className='card text-center'>
          <div className='badge badge-primary'>Followers: {followers} </div>
          <div className='badge badge-success'>Following: {following} </div>
          <div className='badge badge-light'>Public Repos: {public_repos} </div>
          <div className='badge badge-dark'>Public Gists: {public_gists} </div>
        </div>
        <Repos repos={repos} />
      </Fragment>
    );
  }
};

export default User;
